import { Injectable } from '@angular/core';

@Injectable()
export class AppConfig {

  public static baseUrl = '/wp-json/';
  public static transitionTime = 300;

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/app-config.service.ts